import {AfterViewChecked, Component, Inject, Input} from '@angular/core';
import {Cart} from '../../shopping-cart/Cart';
import {CartService} from '../../shopping-cart/cart.service';
import {ActivatedRoute} from '@angular/router';
import {UccpConfiguration} from '../uccp.service';
import {DOCUMENT, NgIf} from '@angular/common';

@Component({
  selector: 'app-make-payment',
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.scss'],
  standalone: true,
  imports: [
    NgIf
  ]
})
export class MakePaymentComponent implements AfterViewChecked {

  @Input()
  uccpConfig: UccpConfiguration;
  @Input()
  submitPayment: boolean;
  @Input()
  cart: Cart;

  constructor(private readonly route: ActivatedRoute,
              private readonly cartService: CartService,
              @Inject(DOCUMENT) private readonly document: Document) {
  }

  ngAfterViewChecked() {
    const form = this.document.forms.namedItem('uccp');
    if (form && this.submitPayment) {
      form.submit();
    }
  }

  get amount() {
    return this.cartService.calcTotals(this.cart).total.toFixed(2);
  }

}
